import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AddFundService } from "./add-fund.service";
import { MatDialogRef } from "@angular/material/dialog";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import ID from "../../types/id";
import { Subscription } from "rxjs";
import { DefaultSnackBarService } from "../../services/default-snack-bar.service";
import { CreateFundInput } from "./graphql/add-fund";
import { formatDate } from "@angular/common";
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar";

@Component({
    selector: 'app-add-fund',
    templateUrl: './add-fund.component.html',
    styleUrls: ['./add-fund.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddFundComponent {
  public formGroup = new FormGroup({
    name: new FormControl("", [Validators.required]),
    legal_name: new FormControl("", [Validators.required]),
    fund_type_id: new FormControl<ID>("", [Validators.required]),
    managing_member_name: new FormControl(""),
    close_date: new FormControl<Date|string>(""),
    invested_equity: new FormControl<number|null>(null),
  })
  constructor(public addFundService: AddFundService, public dialogRef: MatDialogRef<AddFundComponent>, private _snackBar: DefaultSnackBarService, private matSnackBar: MatSnackBar) { }

  saveFund(){
    let sub:Subscription;
    let data = this.formGroup.value;
    let input: CreateFundInput = {
      name:data.name ?? "",
      legal_name:data.legal_name ?? "",
      managing_member_name: data.managing_member_name ?? null,
      invested_equity: data.invested_equity ?? null,
      fund_type_id: data.fund_type_id ?? "",
      close_date: data.close_date ? formatDate(data.close_date, "yyyy-MM-dd", "en-US") : null,
    }
    this.addFundService.fundNameCheck(input.name).subscribe(data => {
      if(data){
        const config = new MatSnackBarConfig();
        config.panelClass = ['save-warning'];
        config.horizontalPosition = 'center';
        config.verticalPosition = 'top';
        config.duration = 3000;
        this.matSnackBar.open('Fund name already exists.', 'Ok', config)
      } else {
        sub = this.addFundService.createFund(input).subscribe(({data, loading})=>{
          this.dialogRef.close(data?.createFund.id);
          this._snackBar.open("Fund Created");
          sub?.unsubscribe();
        })
      }
    })

  }
  ngOnInit() {
    this.addFundService.getFundInfo();
  }
}
